import { Component, OnInit, ViewChild } from '@angular/core';
import { Inject } from '@angular/core';
import { ChartType, ChartOptions, ChartDataSets } from 'chart.js';
import { Color, BaseChartDirective, Label } from 'ng2-charts';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Router } from "@angular/router";
import { PageScrollService } from 'ngx-page-scroll-core';
import { DOCUMENT } from '@angular/common';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import { SlimLoadingBarService } from '@cime/ngx-slim-loading-bar';
import { OptimizerServiceService } from '../optimizer-service.service';
import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Options } from 'ng5-slider';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from "@angular/router";
import { isObject } from 'util';
import * as $ from 'jquery';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';
import{saveAs} from 'file-saver/dist/FileSaver'

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {

  // Statistic Data For Have
  _id: number;
  have_rate_of_return: any;
  have_standard_deviation: any;
  have_variance_drag_phantom_tax: any;
  have_sharpe_ratio: any;
  have_probability_of_any_loss: any;
  have_amount_of_money_at_risk: any;
  have_upper_return: any;
  have_lower_return: any;
  have_beta:any;
  have_upside_capture_ratio:any;
  have_downside_capture_ratio:any


  Formatdate:any;
  CustomerName:any;

  // Statistic Data for Need
  need_id: number;
  need_rate_of_return: any;
  need_standard_deviation: any;
  need_variance_drag_phantom_tax: any;
  need_sharpe_ratio: any;
  need_probability_of_any_loss: any;
  need_amount_of_money_at_risk: any;
  need_upper_return: any;
  need_lower_return: any;

  //Proposed Solutions
  solution_rate_of_return: any;
  solution_standard_deviationsss: any;
  solution_variance_drag_phantom_tax: any;
  solution_sharpe_ratio: any;
  solution_probability_of_any_loss: any;
  solution_amount_of_money_at_risk: any;
  solution_upper_return: any;
  solution_lower_return: any;
  solution_beta: any;
  solution_upside_capture_ratio:any;
  solution_downside_capture_ratio:any;
  solution_ulcer_index:any;
  solution_amount_of_income:any
  solution_income_percentage:any;

  // CHAPVEST_APP_SERVICE_BASE_URL='http://localhost:3000/';
  CHAPVEST_APP_SERVICE_BASE_URL = 'https://node-backend.chapwood.apps.savantly.cloud/';
  CHAPTIMIZER_APP_SERVICE_BASE_URL = 'https://chapwood-optimizer.chapwood.apps.savantly.cloud/';

  //optimizerResult = {"statistics":{},"allocations":[],"allocations_names":[],"allocations_categories":[]};

  optimizerResult = {
    statistics: isObject,
    allocations: [],
    allocations_names: [],
    allocations_categories: [],
    divident_amount:[],
    divident_percentage:[]
  }

  regData = { "investmentAmount": 0, "investment_ror": 0, "maximum_allocation": 0 };
  categories = [];
  categoryIndex = {};
  categoryValues = [];
  assetCategoryInvestments = [];
  finalAllocations = [];
  currentDate = new Date();
  portfolioTrends = { "annual_ror": [], "annual_sd": [], "arr_years": [], "avg_return": 0, "median_return": 0, "min_return": 0, "max_return": 0 };
  monthlyStats = { "monthly_returns": [], "avg_return": 0, "median_return": 0, "min_return": 0, "max_return": 0 };

  /**
   * Pie chart Code
   */
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
      labels: {
        fontSize: 16
      }
    },
    tooltips: {
      enabled: true
    },
    maintainAspectRatio: true,
    plugins: {
      datalabels: {
        //anchor: 'end',
        align: 'end',
        offset: 35,
        font: {
          size: 16,
        },
        /*
        formatter: (value, ctx) => {
          const label = ctx.chart.data.labels[ctx.dataIndex];
          return label;
        },
        */
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          //dataArr.map((data) => {
          //    sum += data;
          //});
          let percentage = Number((value * 100 / this.regData.investmentAmount).toFixed(2));
          if (this.roundInteger(percentage) >= 2) {
            return this.roundInteger(percentage) + "%";
          } else {
            //return this.roundInteger(percentage)+"\n%";
            return "";
          }
        },
        color: '#244768',
      },
    }
  };
  public pieChartLabels: Label[] = [];
  public pieChartData: number[] = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [pluginDataLabels];

  initChart() {
    var category = "";
    var j = 0;
    for (var i = 0; i < this.optimizerResult.allocations_categories.length; i++) {
      category = this.optimizerResult.allocations_categories[i];
      if (category && this.categoryIndex["" + category] != null && this.categoryIndex["" + category] >= 0) {
        continue;
      }
      this.categories.push("" + category);
      this.categoryValues.push(0);
      this.categoryIndex["" + category] = j++;
    }
    var totalValue = 0;
    for (var i = 0; i < this.optimizerResult.allocations.length; i++) {
      category = this.optimizerResult.allocations_categories[i];
      totalValue = this.optimizerResult.allocations[i];
      this.categoryValues[this.categoryIndex["" + category]] += Number(totalValue);
    }
    this.pieChartLabels = this.categories;
    this.pieChartData = this.categoryValues;
  }

  /**
   * Pie chart Code ends here
   */

  constructor(private pageScrollService: PageScrollService, @Inject(DOCUMENT) private document: any, private router: Router,
    private slimLoadingBarService: SlimLoadingBarService, private http: HttpClient,
    private toastr: ToastrService, private route: ActivatedRoute, private dialog: MatDialog,
    public optimizerService: OptimizerServiceService) { }

  ngOnInit() {
    this.optimizerResult = JSON.parse(localStorage.getItem("optimizerResult"));
    this.regData = JSON.parse(localStorage.getItem("optimizerInputs"));
    this.initChart();
    this.transformAllocations();
    this.pageScrollService.scroll({
      document: this.document,
      scrollTarget: '.topHeader',
    });
    this.fetchPortfolioTrends();
    this.fetchAllMonthlyReturns();

    // If there is query params.. then show div element
    if (localStorage.getItem('Current_Need') == "null" && localStorage.getItem('Current_Have') == "null") {
      $(".HideShow").hide();
      // this.ProposedSolution();
    }
    else {

      $(".HideShow").show();
      this.current_need_statistic_data();
      this.current_have_statistic_data();
      // this.ProposedSolution();
      this.setStatistics()
      this.have_beta=localStorage.getItem('beta_avg')
    }

    if (localStorage.getItem('Current_Need') == "null" && localStorage.getItem('Current_Have') == "null") {
      $(".HideShow1").show();
      // this.ProposedSolution();
      this.setStatistics()
    }
    else {

      $(".HideShow1").hide();
      // this.current_need_statistic_data();
      // this.current_have_statistic_data();
      // this.ProposedSolution();
    }

    this.getFormatdate();

  }

  // showModal(): void {
  //   $("#myModal").modal('show');
  // }
  sendModal() {
    this.CustomerName=(<HTMLInputElement>document.getElementById("customername")).value;
    if(this.CustomerName.length>0){
      this.hideModal();
      // this.doPrint();
      this.getPdf()
    }
    else if(this.CustomerName!==""){
      this.showModal();
    }
    (<HTMLInputElement>document.getElementById("customername")).value='';

  }

  getAllocationConstraints(){
    let allocation_const= JSON.parse(localStorage.getItem('tempAllocationConstraintsStore'));
    let allocation_constraints=allocation_const.map(el=>[Number(el[0]/100),Number(el[1])/100])
    return allocation_constraints
  }

  getPdf()
  {
    let apiPayload={
     customerName:this.CustomerName,
     optimize:{
      "Current_Need":{'_id':localStorage.getItem("Current_Need"),'beta':null},
      "Current_Have":{'_id':localStorage.getItem("Current_Have"),'beta':Number(this.have_beta)},
      "allocation_constraints":this.getAllocationConstraints(),
      "investment_amount": this.regData.investmentAmount,
      "max_standard_deviation": localStorage.getItem('maxStandardDeviation'),
      "maximum_allocation": 100,
      "mode": "maximize",
      "target_value": this.regData.investment_ror
     }
    }

    let dialogRef: MatDialogRef<ProgressSpinnerComponent> = this.dialog.open(ProgressSpinnerComponent, {
      panelClass: 'transparent',
      disableClose: true,
    })
    this.http.post(this.optimizerService.getPdfFileURL(),apiPayload,{responseType:'arraybuffer'})
    .subscribe(res=>{
      dialogRef.close()
      if(res.byteLength>5)
      {
      var blob = new Blob([res],{type:'application/pdf'});
      const filename="chaptimizer.pdf"
      saveAs(blob,filename)
      }
    },(err)=>{
      dialogRef.close()
      console.log(err);
      if(err)
      {
        this.toastr.error("Something went wrong!");
      }
    })
  }



  hideModal() {
    document.getElementById('close-modal').click();
  }

  showModal() {
    this.setShowModal(true);
  }

  setShowModal(bool: true) {
    // console.log("hello");
  }

  getFormatdate(){
    const today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    this.Formatdate = mm + '/' + dd + '/' + yyyy;
  }

  transformAllocations() {
    this.finalAllocations = [];
    var category = "";
    for (var catIdx = 0; catIdx < this.categories.length; catIdx++) {
      category = this.categories[catIdx];
      var categoryObj = { "name": category, "assets": [], "total": 0 ,"divident_total":0,"div_per_total":0};
      for (var i = 0; i < this.optimizerResult.allocations.length; i++) {
        if (this.optimizerResult.allocations_categories[i] == category) {
          categoryObj["assets"].push({
            "name": this.optimizerResult.allocations_names[i],
            "value": this.optimizerResult.allocations[i],
            "percent": this.calcPercentage(this.optimizerResult.allocations[i]),
            "div_amt": this.optimizerResult.divident_amount[i],
            "div_per": this.optimizerResult.divident_percentage[i]
          });
          categoryObj["total"] += Number(this.optimizerResult.allocations[i]);
          categoryObj["divident_total"] += Number(this.optimizerResult.divident_amount[i]);
          categoryObj["div_per_total"] += Number(this.optimizerResult.divident_amount[i]);
        }
      }
      this.finalAllocations.push(categoryObj);
    }
    //console.log(this.finalAllocations);
  }

  roundDecimal(numb: number) {
    if (numb) {
      //return Math.round(numb);
      return numb.toFixed(2);
    } else {
      return 0;
    }
  }

  roundDecimalPlaces(numb: number, decimalPlaces: number) {
    if (numb) {
      //return Math.round(numb);
      return numb.toFixed(decimalPlaces);
    } else {
      return 0;
    }
  }

  roundInteger(numb: number) {
    if (numb) {
      //return Math.round(numb);
      return numb.toFixed(0);
    } else {
      return 0;
    }
  }

  truncateDecimal(numb: any) {
    if (numb) {
      return Number(numb).toFixed(0);
    } else {
      return 0;
    }
  }

  calcAmount(numb: number) {
    if (numb && this.regData.investmentAmount) {
      return this.roundInteger(numb * this.regData.investmentAmount);
    } else {
      return 0;
    }
  }

  calcPercentage(numb: number) {
    if (numb && this.regData.investmentAmount) {
      return this.roundDecimal((numb / this.regData.investmentAmount) * 100);
    } else {
      return 0;
    }
  }

  getActualReturns(numb: number) {
    if (numb) {
      return this.roundDecimal(numb);
    } else {
      return 0;
    }
  }

  getProbabilityPercent(numb: number) {
    if (numb) {
      return this.roundDecimal(numb * 100);
    } else {
      return 0;
    }
  }

  getAnnualReturns(numb: number) {
    if (numb) {
      return this.roundDecimal(numb * 12);
    } else {
      return 0;
    }
  }

  // doPrint() {
  //   setTimeout(() => {
  //     window.print();
  //   }, 1000);
  // }

  goBack() {
    this.router.navigate(['/optimizer']);
  }

  startLoading() {
    this.slimLoadingBarService.start(() => {
      console.log('Loading complete');
    });
  }

  stopLoading() {
    this.slimLoadingBarService.stop();
  }

  completeLoading() {
    this.slimLoadingBarService.complete();
  }

  calcRatio(numb: number) {
    if (numb && this.regData.investmentAmount) {
      return numb / this.regData.investmentAmount;
    } else {
      return 0;
    }
  }

  /**
   * Line chart code
   */

  transformAllocationsIntoRatios() {
    var i = 0;
    var allocationRatios = [];
    if (this.optimizerResult.allocations) {
      for (i = 0; i < this.optimizerResult.allocations.length; i++) {
        allocationRatios[i] = Number(this.calcRatio(this.optimizerResult.allocations[i]));
      }
    }
    return allocationRatios;
  }

  fetchPortfolioTrends() {
    let dialogRef: MatDialogRef<ProgressSpinnerComponent> = this.dialog.open(ProgressSpinnerComponent, {
      panelClass: 'transparent',
      disableClose: true,
    })
    this.startLoading();
    var allocationRatios = this.transformAllocationsIntoRatios();
    return this.http.post(
      this.optimizerService.getPortfolioTrendEndpointURL(),
      {
        "allocations": allocationRatios
      }).subscribe((data: any) => {
        this.completeLoading();
        dialogRef.close();
        this.portfolioTrends = { "annual_ror": [], "annual_sd": [], "arr_years": [], "avg_return": 0, "median_return": 0, "min_return": 0, "max_return": 0 };
        this.portfolioTrends = data;
        this.loadPortfolioTrendsData(data);
        this.loadHistogramData1();
      }, (error: any) => {
        this.completeLoading();
        dialogRef.close();
        if (error.status == 500) {
          this.toastr.error('Server ERROR! Please try again later!!');
        } else {
          this.toastr.error('Network ERROR!');
        }
      });
  }

  public lineChartData: ChartDataSets[] = [
    { data: [0], label: 'Please wait..' },
    { data: [0], label: 'Please wait..' }
  ];
  public lineChartLabels: Label[] = ['-'];

  loadPortfolioTrendsData(response_data: any) {
    var i = 0;
    this.lineChartData = [];
    var series_ror = { label: "Rate Of Return (%)", data: [], borderColor: [], backgroundColor: [] };
    var series_sd = { label: "Standard Deviation (%)", data: [], borderColor: [], backgroundColor: [] };
    if (response_data.arr_years) {
      this.lineChartLabels = response_data.arr_years;
    }
    if (response_data.annual_ror) {
      for (i = 0; i < response_data.annual_ror.length; i++) {
        series_ror.data.push(this.roundDecimalPlaces(response_data.annual_ror[i], 1));
        series_ror.backgroundColor.push("rgba(15,120,189,0.1)");
        series_ror.borderColor.push("rgba(15,120,189,1)");
      }
      this.lineChartData.push(series_ror);
    }
    if (response_data.annual_sd) {
      for (i = 0; i < response_data.annual_sd.length; i++) {
        series_sd.data.push(this.roundDecimalPlaces(response_data.annual_sd[i], 1));
        series_sd.backgroundColor.push("rgba(233,201,46,0.1)");
        series_sd.borderColor.push("rgba(233,201,46,1)");
      }
      this.lineChartData.push(series_sd);
    }
  }

  public lineChartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
    title: {
      display: true,
      text: ""
    },
    legend: {
      position: 'bottom',
      labels: {
        fontSize: 20
      }
    },
    tooltips: {
      enabled: true
    },
    plugins: {
      datalabels: {
        align: 'end',
        font: {
          size: 16,
        }
      }
    },
    maintainAspectRatio: true,
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      xAxes: [{}],
      yAxes: [
        {
          id: 'y-axis-0',
          position: 'left',
        },
        {
          id: 'y-axis-1',
          position: 'right',
          gridLines: {
            color: 'rgba(255,0,0,0.3)',
          },
          ticks: {
            //fontColor: '#444'
          }
        }
      ]
    },
    annotation: {
      annotations: [
        {
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: 'March',
          borderColor: 'orange',
          borderWidth: 2,
          label: {
            enabled: true,
            fontColor: 'orange',
            content: 'LineAnno'
          }
        },
      ],
    },
  };
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [pluginAnnotations];

  @ViewChild(BaseChartDirective, {}) chart: BaseChartDirective;

  showUpArrowRoR(numb: number) {
    if (numb && this.optimizerResult && this.optimizerResult.statistics && this.optimizerResult.statistics["rate_of_return"]) {
      if (numb >= this.optimizerResult.statistics["rate_of_return"]) {
        return 1;
      } else {
        return 0;
      }
    }
    return -1;
  }

  showUpArrowSD(numb: number) {
    if (numb && this.optimizerResult && this.optimizerResult.statistics && this.optimizerResult.statistics["standard_deviation"]) {
      if (numb >= this.optimizerResult.statistics["standard_deviation"]) {
        return 1;
      } else {
        return 0;
      }
    }
    return -1;
  }

  /**
   * Line chart code ends here
   */


  /**
   *  Monthly Histogram code starts here
   */

  fetchAllMonthlyReturns() {
    this.startLoading();
    var allocationRatios = this.transformAllocationsIntoRatios();
    return this.http.post(
      this.optimizerService.getMonthlyReturnsEndpointURL(),
      {
        "allocations": allocationRatios
      }).subscribe((data: any) => {
        this.completeLoading();
        this.monthlyStats = { "monthly_returns": [], "avg_return": 0, "median_return": 0, "min_return": 0, "max_return": 0 };
        this.monthlyStats = data;
        this.loadHistogramData(data);
      }, (error: any) => {
        this.completeLoading();
        if (error.status == 500) {
          this.toastr.error('Server ERROR! Please try again later!!');
        } else {
          this.toastr.error('Network ERROR!');
        }
      });
  }

  public barChartOptions: ChartOptions = {
    responsive: true,
    title: {
      display: true,
      text: ""
    },
    // We use these empty structures as placeholders for dynamic theming.
    scales: { xAxes: [{}], yAxes: [{}] },
    legend: {
      position: 'bottom',
      labels: {
        fontSize: 20
      }
    },
    tooltips: {
      enabled: true
    },
    maintainAspectRatio: true,
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        font: {
          size: 20,
        }
      }
    }
  };
  public barChartLabels: Label[] = ['please wait..'];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];

  public barChartData: ChartDataSets[] = [
    { data: [0], label: 'Please wait..' }
  ];

  loadHistogramData(response_data: any) {
    //var minVal = this.roundInteger(this.monthlyStats.min_return-1);
    //var maxVal = this.roundInteger(this.monthlyStats.max_return+1);
    //var minVal = -20;
    //var maxVal = 20;

    //var arrRange = [[-99999,-20],[-20,-18],[-18,-16],[-16,-14],[-14,-12],[-12,-10],[-10,-8],[-8,-6],[-6,-4],[-4,-2],[-2,0],[0,2],[2,4],[4,6],[6,8],[8,10],[10,12],[12,14],[14,16],[16,18],[18,20],[20,99999]];
    var arrRange = [];
    var startIdx = -20;
    var endIdx = 20;
    var increment = 2;
    var MINVAL = -99999;
    var MAXVAL = 99999;
    for (var i = startIdx; i <= endIdx; i += increment) {
      if (i == startIdx) {
        arrRange.push([MINVAL, i]);
        arrRange.push([i, i + increment]);
      } else if (i == endIdx) {
        arrRange.push([i, MAXVAL]);
      } else {
        arrRange.push([i, i + increment]);
      }
    }

    var arrRangeLabels = [];
    var arrRangeValues = [];
    for (var i = 0; i < arrRange.length; i++) {
      arrRangeValues[i] = 0;
      if (i == 0) {
        arrRangeLabels[i] = "< " + arrRange[i][1] + "%";
      } else if (i == arrRange.length - 1) {
        arrRangeLabels[i] = "> " + arrRange[i][0] + "%";
      } else {
        arrRangeLabels[i] = arrRange[i][0] + "% To " + arrRange[i][1] + "%";
      }
    }
    this.barChartLabels = arrRangeLabels;

    var tempVal = 0.0;
    for (var i = 0; i < this.monthlyStats.monthly_returns.length; i++) {
      tempVal = this.monthlyStats.monthly_returns[i];
      for (var j = 0; j < arrRange.length; j++) {
        if (tempVal >= arrRange[j][0] && tempVal < arrRange[j][1]) {
          arrRangeValues[j] = arrRangeValues[j] + 1;
          break;
        }
      }
    }
    this.barChartData = [];
    var series_ror = { label: "Monthly Returns Histogram", data: [], backgroundColor: [] };
    for (var i = 0; i < arrRangeValues.length; i++) {
      series_ror.data.push(arrRangeValues[i]);
      series_ror.backgroundColor.push("#0f78bd");
    }
    this.barChartData.push(series_ror);
  }

  /**
   *  Monthly Histogram code ends here
   */


  /**
  *  Yearly Histogram code starts here
  */

  public barChartOptions1: ChartOptions = {
    responsive: true,
    title: {
      display: true,
      text: ""
    },
    // We use these empty structures as placeholders for dynamic theming.
    scales: { xAxes: [{}], yAxes: [{}] },
    legend: {
      position: 'bottom',
      labels: {
        fontSize: 20
      }
    },
    tooltips: {
      enabled: true
    },
    maintainAspectRatio: true,
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        font: {
          size: 20,
        }
      }
    }
  };
  public barChartLabels1: Label[] = ['please wait..'];
  public barChartType1: ChartType = 'bar';
  public barChartLegend1 = true;
  public barChartPlugins1 = [pluginDataLabels];

  public barChartData1: ChartDataSets[] = [
    { data: [0], label: 'Please wait..' }
  ];

  loadHistogramData1() {
    //var arrRange = [[-99999,-20],[-20,-18],[-18,-16],[-16,-14],[-14,-12],[-12,-10],[-10,-8],[-8,-6],[-6,-4],[-4,-2],[-2,0],[0,2],[2,4],[4,6],[6,8],[8,10],[10,12],[12,14],[14,16],[16,18],[18,20],[20,99999]];
    var arrRange = [];
    var startIdx = -50;
    var endIdx = 50;
    var increment = 5;
    var MINVAL = -99999;
    var MAXVAL = 99999;
    for (var i = startIdx; i <= endIdx; i += increment) {
      if (i == startIdx) {
        arrRange.push([MINVAL, i]);
        arrRange.push([i, i + increment]);
      } else if (i == endIdx) {
        arrRange.push([i, MAXVAL]);
      } else {
        arrRange.push([i, i + increment]);
      }
    }

    var arrRangeLabels = [];
    var arrRangeValues = [];
    for (var i = 0; i < arrRange.length; i++) {
      arrRangeValues[i] = 0;
      if (i == 0) {
        arrRangeLabels[i] = "< " + arrRange[i][1] + "%";
      } else if (i == arrRange.length - 1) {
        arrRangeLabels[i] = "> " + arrRange[i][0] + "%";
      } else {
        arrRangeLabels[i] = arrRange[i][0] + "% To " + arrRange[i][1] + "%";
      }
    }
    this.barChartLabels1 = arrRangeLabels;

    var tempVal = 0.0;
    for (var i = 0; i < this.portfolioTrends.annual_ror.length; i++) {
      tempVal = this.portfolioTrends.annual_ror[i];
      for (var j = 0; j < arrRange.length; j++) {
        if (tempVal >= arrRange[j][0] && tempVal < arrRange[j][1]) {
          arrRangeValues[j] = arrRangeValues[j] + 1;
          break;
        }
      }
    }
    this.barChartData1 = [];
    var series_ror = { label: "Yearly Returns Histogram", data: [], backgroundColor: [] };
    for (var i = 0; i < arrRangeValues.length; i++) {
      series_ror.data.push(arrRangeValues[i]);
      series_ror.backgroundColor.push("#0f78bd");
    }
    this.barChartData1.push(series_ror);

  }

  /**
   *  Yearly Histogram code ends here
   */


  current_have_statistic_data() {
    let url2 = this.CHAPVEST_APP_SERVICE_BASE_URL + 'statistics/' + localStorage.getItem('Current_Have');
    // alert('Have '+url2);
    this.http.get(url2).subscribe((res: Response) => {
      let userResponses2 = JSON.parse(JSON.stringify(res));
      console.log(userResponses2);
      this.have_rate_of_return = userResponses2.rate_of_return;
      this.have_standard_deviation = userResponses2.standard_deviation;
      this.have_variance_drag_phantom_tax = userResponses2.variance_drag_phantom_tax;
      this.have_sharpe_ratio = userResponses2.sharpe_ratio;
      this.have_probability_of_any_loss = userResponses2.probability_of_any_loss;
      this.have_amount_of_money_at_risk = userResponses2.amount_of_money_at_risk;
      this.have_upper_return = userResponses2.upper_return;
      this.have_lower_return = userResponses2.lower_return
    })
  }

  current_need_statistic_data() {
    //let url3 = 'http://13.57.236.169:3000/statistics/' + localStorage.getItem('user_current_need_statistic');
    let url3 = this.CHAPVEST_APP_SERVICE_BASE_URL + 'statistics/' + localStorage.getItem('Current_Need');
    this.http.get(url3).subscribe((res: Response) => {
      let userResponses3 = JSON.parse(JSON.stringify(res));
      console.log(userResponses3);
      this.need_rate_of_return = userResponses3.rate_of_return;
      localStorage.setItem("rate of return", userResponses3.rate_of_return)
      this.need_standard_deviation = userResponses3.standard_deviation;
      localStorage.setItem("standard Deviation", userResponses3.standard_deviation)
      this.need_variance_drag_phantom_tax = userResponses3.variance_drag_phantom_tax;
      this.need_sharpe_ratio = userResponses3.sharpe_ratio;
      this.need_probability_of_any_loss = userResponses3.probability_of_any_loss;
      this.need_amount_of_money_at_risk = userResponses3.amount_of_money_at_risk;
      this.need_upper_return = userResponses3.upper_return;
      this.need_lower_return = userResponses3.lower_return;
    })
  }

  ProposedSolution() {
    let dialogRef: MatDialogRef<ProgressSpinnerComponent> = this.dialog.open(ProgressSpinnerComponent, {
      panelClass: 'transparent',
      disableClose: true,
    })
    let url3 = this.CHAPTIMIZER_APP_SERVICE_BASE_URL + 'optimize';
    let allocation_range_constraints = this.getAllocationConstraints();
    this.http.post(url3, {
      "allocation_constraints": allocation_range_constraints,
      "investment_amount": this.regData.investmentAmount,
      "max_standard_deviation": localStorage.getItem('maxStandardDeviation'),
      "maximum_allocation": 100,
      "mode": "maximize",
      "target_value": this.regData.investment_ror,
      "uuid":localStorage.getItem('uuid')
    }).subscribe((data: any) => {
      dialogRef.close()
      let userResponse4 = JSON.parse(JSON.stringify(data));
      console.log(userResponse4);
      console.log(userResponse4.statistics);
      this.solution_rate_of_return = userResponse4.statistics.rate_of_return;
      this.solution_standard_deviationsss = userResponse4.statistics.standard_deviation;
      this.solution_variance_drag_phantom_tax = userResponse4.statistics.variance_drag_phantom_tax;
      this.solution_sharpe_ratio = userResponse4.statistics.sharpe_ratio;
      this.solution_probability_of_any_loss = userResponse4.statistics.probability_of_any_loss
      this.solution_amount_of_money_at_risk = userResponse4.statistics.amount_of_money_at_risk;
      this.solution_upper_return = userResponse4.statistics.upper_return;
      this.solution_lower_return = userResponse4.statistics.lower_return;
      this.solution_beta = userResponse4.statistics.beta;
      this.solution_downside_capture_ratio=userResponse4.statistics.downside_capture_ratio;
      this.solution_upside_capture_ratio=userResponse4.statistics.upside_capture_ratio;
      this.solution_ulcer_index=userResponse4.statistics.ulcer_index;
      this.solution_amount_of_income=userResponse4.statistics.amount_of_income;
      this.solution_income_percentage=userResponse4.statistics.percentage_of_income;
    })
  }

  setStatistics(){

    let stats=JSON.parse(localStorage.getItem('saved_statistics'))

    this.solution_rate_of_return = stats.rate_of_return;
    this.solution_standard_deviationsss = stats.standard_deviationsss;
    this.solution_variance_drag_phantom_tax = stats.variance_drag_phantom_tax;
    this.solution_sharpe_ratio = stats.sharpe_ratio;
    this.solution_probability_of_any_loss = stats.probability_of_any_loss;
    this.solution_amount_of_money_at_risk = stats.amount_of_money_at_risk;
    this.solution_upper_return = stats.upper_return;
    this.solution_lower_return = stats.lower_return;
    this.solution_beta = stats.beta;
    this.solution_downside_capture_ratio= stats.downside_capture_ratio;
    this.solution_upside_capture_ratio= stats.upside_capture_ratio;
    this.solution_ulcer_index= stats.ulcer_index;
    this.solution_amount_of_income=stats.amount_of_income;
      this.solution_income_percentage=stats.percentage_of_income;
  }
}
